export const A1MOBILSOFT_LOGO = '/A1mobilsoft_logo_a.svg';
export const LOGO_BY_CHANNEL = {
  myrealtrip: '/myrealtrip/myrealtrip_trimo_logo_black.png',
  waug: '/waug/waug_trimo_logo_black.png',
  zzimcar: '/zzimcar/zzimcar_trimo_logo.png',
  trimo: '/trimo/trimo_logo_black.png',
  tourvis: '/tourvis/tourvis_trimo_logo.png',
};
export const VENDOR_LOGOS = {
  ZE: 'vendors/logo_hertz.png',
  ZR: 'vendors/logo_dollar.png',
  ZT: 'vendors/logo_thrifty.png',
  TM: 'vendors/logo_tumon.png',
  RC: 'vendors/logo_rich.png',
  OR: 'vendors/logo_orix.png',
} as const;
